if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        if (!this.openedBy) return;

        const mediaId = this.openedBy.getAttribute('data-media-id');
        if (!mediaId) return;

        this.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('active', 'is-active');
        });

        const activeMedia = this.querySelector(
          `[data-media-id="${mediaId}"]`
        );

        if (!activeMedia) return;

        activeMedia.classList.add('active', 'is-active');
        activeMedia.scrollIntoView({
          block: 'nearest',
          inline: 'nearest'
        });
      }
    }
  );
}
